const $ = require('jquery');
const util = require('./util.js');

var summaryCallbackDispatcher = {};

function addSummaryCallback(callback) {
    $.extend(summaryCallbackDispatcher, callback);
}
function deleteSummaryCallback(key) {
    delete summaryCallbackDispatcher[key];
}

var scl_fieldObject = (function () {
    var self = {
        'options': {
            'rowdata': {}
        }
        , 'init': function (options) {
            this.options = $.extend(this.options, (options || {}));
        }
        , 'getObjet': function () {
            return this.options.rowdata;
        }
        , 'getSortFunc': function (order) {
            var x = null;
            var _this = this;

            if (!this.type) {
                this.type = 'string';
            }

            switch (this.type) {
                case 'string':
                    x = function (a, b) {
                        if (order == 'asc') {
                            return sortText(_this.getSortValue(a), _this.getSortValue(b));
                        } else {
                            return sortText(_this.getSortValue(b), _this.getSortValue(a));
                        }
                    }
                    break;
                case 'numeric':
                    x = function (a, b) {
                        if (order == 'asc') {
                            return sortNumeric(_this.getSortValue(a), _this.getSortValue(b));
                        } else {
                            return sortNumeric(_this.getSortValue(b), _this.getSortValue(a));
                        }
                    }
                    break;
            }
            return x;
        }
        , 'getSortValue': function (x) {
            return this.getDisplayValue(x);
        }
        , 'getDisplayHtml': function (x) {
            return this.getDisplayValue(x);
        }
        , 'getDisplayValue': function (x) {
            return 'Display : not set';
        }
        , 'getSearchValue': function (x) {
            var dispval = this.getDisplayValue(x);
            if (dispval) {
                return dispval;
            } else {
                return '-';
            }
        }
    };
    return self;
})();

function sortText(a, b) {
    if (typeof (a) == "number" && typeof (b) == "number") { return sortNumeric(a, b); }
    if (
            typeof (a) == 'undefined'
            || a === null
       ) {
        return -1;
    }
    if (
            typeof (b) == 'undefined'
            || b === null
       ) {
        return 1;
    }
    aa = a.toLowerCase();
    bb = b.toLowerCase();
    return ((aa < bb) ? -1 : ((aa > bb) ? 1 : 0));
};

function sortNumeric(a, b) {
    if (typeof (a) == 'undefined') {
        return -1;
    }
    if (typeof (b) == 'undefined') {
        return 1;
    }
    return a - b;
};

function getTimestampFromDateString(datestring) {
    myDate = datestring.split("-");
    ts = new Date(parseInt(myDate[0], 10), parseInt(myDate[1], 10) - 1, parseInt(myDate[2]), 10).getTime();
    return ts;
}

//// js does not have sprintf...
function formatNumberTo2Digits(n) {
    return n > 9 ? "" + n : "0" + n;
}



var fieldObject_dispatcher = {};

function getFieldObject(fieldName) {

    //Désactive le Focus sur l'input rempli afin d'eviter le double click sur un lien
    document.activeElement.blur();

    if (typeof (fieldObject_dispatcher[fieldName]) != 'undefined') {
        return fieldObject_dispatcher[fieldName];
    } else if (fieldName.substring(0, 5) == 'date_') {
        var initObj = $.extend({}, scl_fieldObject);
        initObj.type = 'numeric';
        var thisFieldName = fieldName;
        initObj.getDisplayValue = function (rowdata) {
            if (!rowdata[thisFieldName] || rowdata[thisFieldName] == 0) {
                return '-';
            } else {
                return util.intToDatetime(rowdata[thisFieldName]);
            }
        };
        initObj.getSortValue = function (rowdata) {
            return rowdata[thisFieldName];
        }
        return initObj;

        //} else if(fieldName == 'starttime' || fieldName == 'endtime'){
} else if (fieldName.substring(0, 5) == 'time_') {
    var initObj = $.extend({}, scl_fieldObject);
    initObj.type = 'numeric';
    initObj.getDisplayValue = function (rowdata) {
        var total_minutes = rowdata[fieldName] / 60;
        var hh = formatNumberTo2Digits(Math.floor(total_minutes / 60));
        var mm = formatNumberTo2Digits(total_minutes % 60);
        return hh + ':' + mm;
    };
    initObj.getSortValue = function (rowdata) {
        return rowdata[fieldName];
    }
    return initObj;

} else if (fieldName == 'day_of_service') {
    var dayArray = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    var initObj = $.extend({}, scl_fieldObject);
    initObj.type = 'numeric';
    initObj.getDisplayValue = function (rowdata) {
        var index = rowdata[fieldName] - 1;
        return dayArray[index];
    };
    initObj.getSortValue = function (rowdata) {
        return rowdata[fieldName];
    }
    initObj.getSelectFilters = function (tabledata) {
        return dayArray;
    };
    return initObj;

} else {
    var initObj = $.extend({}, scl_fieldObject);
    initObj.type = 'string';
    var thisFieldName = fieldName;
    initObj.getDisplayValue = function (rowdata) {
        return rowdata[thisFieldName];
    };
    return initObj;
}
}

function initFeedFields() {

}


function fillList(elem, options) {

    var tableRef = $(elem);
    ////////////////////////// CALLBACK /////////
    /////// handle response
    if (options.callback) {
        var callback = options.callback;
    } else {
        var callback = function (dataReceived) {
            dataRecObj = $.parseJSON(dataReceived);
            options['data'] = dataRecObj;
            displayList(tableRef, options);
        };
    }
    // send data REST style
    $.ajax({
            type: 'GET',
            url: options.url, 
            contentType: 'text json',
            dataType: null,
            success: callback,

                // show loader
            beforeSend: function () {
                $('#divAjaxLoader').show();
            },
            complete: function () {
                $('#divAjaxLoader').hide();
            },
            error: function () {
                alert('Erreur affichage');
                $('#divAjaxLoader').hide();
            } 
        });
}


function displayList(elem, options) {

    //// make listData global
    var key = options.uriOptions.q;
    if(!window.listData){window.listData={};}
    window.listData[key] = options['data'][key];
    if ($('select.searchInput', elem).length > 0) {
        // feature flag
        initSelectFilter(elem, options);
    }
    ///////// useless
    //$(elem).each(function () {
    //refillTable($(this), options);
    refillTable(elem[0], options);
    ///// handle anchor
    if (window.location.hash != '' && $(window.location.hash).length > 0) {
        $(document.body).animate({
            'scrollTop': $(window.location.hash).offset().top
        }, 1); /// lightning fast
    }

    //});
}

// cette fonction remplit le contenu des select de filtrage avec le resultat de fieldObject.getSelectFilters
// et gère les evenement change -> refill
function initSelectFilter(elem, options) {
    $('select.searchInput', elem).each(function () {
        var thisSelectTag = $(this);
        var fieldName = $(this).closest('td, .fake_th').attr('title')
            var fieldObject = getFieldObject(fieldName);
        if (fieldObject != null && fieldObject.getSelectFilters) {
            $.each(fieldObject.getSelectFilters(options['data'][$(elem).attr('id')]), function () {
                thisSelectTag.append('<option value="' + this + '">' + this + '</option>');
            });
        }
        // normalement ce block est inutile
        thisSelectTag.change(function () {

            if ($(this).closest('.fake_th').length == 0) {
                // original to fake value copy
                $('.fake_th select.searchInput', elem).val($(this).val());
            } else {
                // fake to original value copy
                $('thead select.searchInput', elem).val($(this).val());
            }
            options.multifilter = true;
            refillTable(elem, options);
        });
        // </ inutile
    });
}

function refillTable(elem, options) {
    options = options || {};
    var tableData;

    //// ASSUMPTION: window.listData initiated
    // TODO: error if undefined
    tableData = window.listData[$(elem).attr('id')];

    // we need to initialize rowClone - DOM element to duplicate
    if ($(elem).data('rowClone') == null) {
        // We MUST duplicate the tbody > tr:first and not the thead to not duplicate Table head titles
        var rowToDuplicate = $('tbody > tr:first, .scl_list_elem:first', elem);
        var rowClone = rowToDuplicate.clone(true);
        // cache object to be reused
        $(elem).data('rowClone', rowClone);
        // we don't want the template row to stick around
        rowToDuplicate.remove();
    }


    // init fillOptions
    window.fillOptions = {};
    var rowDesc = $(elem).data('rowClone');
    $('td, .scl_list_value', rowDesc).each(function () {
        var fieldName = $(this).attr('title');
        if ($(this).hasClass('list_checkbox')) {
            var fieldObject = getFieldObject('list_checkbox');
        } else {
            var fieldObject = getFieldObject(fieldName);
        }
        if (fieldObject != null) {
            if (fieldObject.roundPrecision) {
                var oldfunc = fieldObject.getDisplayValue;
                fieldObject.getDisplayValue = function (rowdata) {
                    if (oldfunc(rowdata) === null) return '_';
                    return parseFloat(oldfunc(rowdata)).toFixed(fieldObject.roundPrecision);
                    //return Math.round( oldfunc(rowdata) * Math.pow(10,fieldObject.roundPrecision) ) / Math.pow(10,fieldObject.roundPrecision);
                }
            }
            window.fillOptions[fieldName] = fieldObject;
        }
    });



    if (options.multifilter) {
        var search_array = $('thead .searchInput, .fake_thead .searchInput').map(function (i, elem) {
            var search_value = $(elem).val();
            if (search_value != '') {
                return {
                    fieldObject: getFieldObject(
                                         getFieldName(elem)
                                         ),
                    searchString: search_value
                };
            }
        });
    } else if (options.action == 'search') {
        ////////////////////////// deprecated
        var search_array = [{
            fieldObject: getFieldObject(options.fieldName),
            searchString: options.searchString
        }];
        //var searchRegex = new RegExp(options.searchString.toLowerCase(),'');
        //////////////////////////////////////
    } else if (options.search_array) {
        // filtrage manuel (ex: sign up CK)
        var search_array = options.search_array;
    }
    var newTableData = [];

    // run filters
    if (search_array && search_array.length != 0) {
        for (index in tableData) {
            // apply each filter
            var matched = true;
            // iterate through search params
            // if ONE is false then ALL is false  (A && B && C)
            $(search_array).each(function () {
                if (this.fieldObject != null
                        && this.fieldObject.validateRow
                   ) {
                    // Specific behaviour
                    if (!this.fieldObject.validateRow(tableData[index], this.searchString)) {
                        matched = false;
                        /// break each loop
                        return false;
                    }
                } else if (
                        !this.fieldObject
                        ||
                        !this.fieldObject.getSearchValue(tableData[index])
                        ||
                        this.fieldObject
                        .getSearchValue(tableData[index])
                        .toLowerCase()
                        .match(new RegExp(this.searchString.toLowerCase(), '')) === null
                        ) {
                    matched = false;
                    /// break each loop
                    return false;
                }
            });
            if (matched) {
                // Default behaviour
                // DEEP COPY
                newTableData.push($.extend(true, {}, tableData[index]));
            }
        }
    } else {
        newTableData = tableData;
    }

    /////////////// SORT
    if (options.multifilter && $('thead a.active, .fake_th a.active').length > 0) {
        ///// fetch which field is activated in sort mode
        ///// a.active represents a sort is active currently
        var sortObject = getFieldObject(getFieldName($('thead a.active, .fake_th a.active')))
            var sort_direction = $('thead a.active, .fake_th a.active').attr('rel').toLowerCase();
        var sortFunc = sortObject.getSortFunc(sort_direction);
        newTableData.sort(sortFunc);
    } else {
        ///////////////////////////////////
        ////// deprecated
        var sortFunc = null;
        var fieldObject = null;
        if (typeof (options.fieldName) != 'undefined') {
            fieldObject = getFieldObject(options.fieldName);
        }
        if (options.action == 'sortASC') {
            sortFunc = fieldObject.getSortFunc('asc');
        }
        if (options.action == 'sortDESC') {
            sortFunc = fieldObject.getSortFunc('desc');
        }
        if (sortFunc != null) {
            newTableData.sort(sortFunc);
        }
        /////////////////////////////////////////
    }

    refreshDisplay(elem, options, newTableData);

}

function refreshDisplay(elem, options, newTableData) {

    $.each(summaryCallbackDispatcher, function () {
        this(newTableData);
    });


    // clear the table
    $('tbody', elem).empty();
    $('.scl_list_elem', elem).remove();
    // Print rows
    for (index in newTableData) {
        var newRow = addRow($(elem), newTableData[index]);
        //if (options.fillRowId) {
        //	options.fillRowId(newRow, newTableData[index]);
        //}
    }

    //// different data means different column widths, hence refresh headers
    //adjustHeaderWidth();


}


///////////////////////////////////////
//var rowCount = 0;

function addRow(elem, fillData) {
    // to be applied on table tag
    // create and insert cloned sub section
    var newClone = $(elem).data('rowClone').clone(true);

    // fill newClone with data
    $('td, .scl_list_value', newClone).each(function () {
        var fieldName = $(this).attr('title');
        if (window.fillOptions[fieldName]) {
            // if a function exists to do some formating apply it
            // note: it could be extra html marker, hence the use of html()
            if (window.fillOptions[fieldName].alterClone) {
                window.fillOptions[fieldName].alterClone(fillData, newClone);
            } else {
                var htmlContent = window.fillOptions[fieldName].getDisplayHtml(fillData);
                $(this).html(htmlContent);
                var old_href = $('a', $(this)).each(function () {
                    $(this).attr('href', encodeURI($(this).attr('href')));
                });
            }
        } else {
            $(this).text(fillData[fieldName]);
        }
    });

    // firefox seems to include a tbody tag even if not there
    $(elem).append(newClone);

    return newClone;

}

/////////////////////////////////////////// initDisplayList
function initDisplayList(inputoptions) {
    var options = inputoptions ? inputoptions : {};
    /// some default fields
    initFeedFields();

    $.each(summaryCallbackDispatcher, function (key, value) {
        /////// SHOW SUMMARY FIELD
        $('.summary-feed#' + key).show();
    });

    //// feature flag
    if ($('thead, .fake_thead').length > 0) {

        /////// sort action
        $('thead td a, .fake_thead .fake_th a').click(function (event) {
            var rel = jQuery(this).attr('rel');
            $('thead td a, .fake_thead .fake_th a').removeClass('active');
            $(this).addClass('active');
            //alert(rel);
            event.preventDefault();
            event.stopPropagation();
            // var fieldid = $(this).closest('td').attr('title');
            refillTable(
                    $(this).closest('table, .scl_list'),

                    {
                        multifilter: true
                    }
                    );
        });

        /////// search action
        $('thead td .searchInput,.fake_thead .fake_th .searchInput ').on('blur', function (event) {
            //var val = jQuery(this).val();
            event.preventDefault();
            event.stopPropagation();
            //var fieldid = $(this).closest('td, .fake_th').attr('title');
            refillTable(
                    $(this).closest('table, .scl_list'),
                    {
                        multifilter: true
                    }
                    );
        });

        $('thead td .searchInput, .fake_thead .fake_th .searchInput').keydown(function (e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode == 13) { // entrée
                // var val = jQuery(this).val();
                e.preventDefault();
                e.stopPropagation();
                // var fieldid = $(this).closest('td, .fake_th').attr('title');
                // var table = $(this).closest('td, .fake_th').parent();
                refillTable(
                        //$(this).closest('td, .fake_th').parent(),
                        $(this).closest('table, .scl_list'),
                        {
                            multifilter: true
                        }
                        );
            }
        });
    }
}

function initListCheckbox() {
    $('.select_all').click(function () {
        //var all_cb = $('.list_checkbox.'+$(this).closest('[title=list_checkbox]').attr('id'));
        var fieldName = $(this).closest('.list_checkbox').attr('title');
        var all_cb = $('[title=' + fieldName + '] input[type=checkbox]');
        if ($(this).prop('checked') == true) {
            $(all_cb).attr('checked', 'checked');
        } else {
            $(all_cb).removeAttr('checked');
        }
    })
}

function execListAction(options) {
    var data = [];
    var elem = options.elem,
    type = options.type,
        action = options.action,
        target_url = options.target_url,
            http_method = options.http_method || 'PUT' // put by default
                var fieldName = $(elem).closest('.list_' + type).attr('title');
    // fetch all column elems by its title
    if (type == 'checkbox') {
        var all_elems = $('[title=' + fieldName + '] input[type=checkbox]:not(.select_all)');
    } else if (type == 'star') {
        var all_elems = elem;
    } else {
        var all_elems = $('[title=' + fieldName + '] ' + type);
    }
    $(all_elems).each(function () {
        var res = action($(this));
        if (res) {
            data.push(res);
        }
    });

    if(options.redirectPreprocess){
        urlParams = options.redirectPreprocess(data);
        window.location.href=target_url+urlParams;
    } else {
        var dataToSend = JSON.stringify(data);
        $.ajax({
            type: http_method,
            url: target_url,
            contentType: 'text json',
            data: dataToSend,
            dataType: null,
                // alter update button icon depending on status
            success: function () {
                $('[title=' + fieldName + '] .list_' + type + '_action i').replaceWith('<i class="fa fa-check"></i>');
                setTimeout(function () { $('[title=' + fieldName + '] .list_' + type + '_action i').replaceWith('<i class="fa fa-refresh"></i>'); }, 3000);
            },
            error: function () {
                $('[title=' + fieldName + '] .list_' + type + '_action i').replaceWith('<i class="fa fa-times"></i>');
            },
            beforeSend: function () {
                $('[title=' + fieldName + '] .list_' + type + '_action i').replaceWith('<i class="fa fa-spinner fa-spin"></i>');
            },
        });
    }

}

function displayFill(options) {

    /********* : bouge dans includes/sophiacloud/pages/FeedDisplay.php
      require(['skins'], function(skins){
      if(skins && skins.initFeedFields){
      skins.initFeedFields();
      }
      if(skins && skins.initFeedDisplay){
      skins.initFeedDisplay(options.feed_name);
      }
      });******************/

    var query_params = options['query_params'];

    uriFeedOptions = $.extend(
            query_params,
            {
                /// for now service part of set2, but this will change, for more configuration
                base_uri: 'sophiacloud/data_mgr.php?s=feed'
            }
            );

    initDisplayList(options['init_options']);

    fillList(
            $('table, .scl_list', '.feedanchor'),
            {
                uriOptions: uriFeedOptions

                    ///// TODO : refactor this as it is not general
                    /*, fillRowId: function (elem, data) {
                      elem.attr('id', data['service_id']);
                      }*********************************************/


            }
            );

}

function getFieldName(elem) {
    //return $(elem).parent().parent().attr('title')
    var fieldHeader = $(elem).closest('*[title]');
    return fieldHeader.attr('title')
}

module.exports= {
    scl_fieldObject: scl_fieldObject,
    fieldObject_dispatcher: fieldObject_dispatcher,
    initDisplayList: initDisplayList,
    execListAction: execListAction,
    addSummaryCallback: addSummaryCallback,
    fillList: fillList,
    displayList: displayList,
    refillTable: refillTable,
    addRow: addRow,
    displayFill: displayFill
};

